import { Component, OnInit } from '@angular/core';
import { PaymentStatusService } from 'src/app/services/payments/payment-status.service';

@Component({
  selector: 'app-payment-status',
  templateUrl: './payment-status.component.html',
  styleUrls: ['./payment-status.component.css']
})
export class PaymentStatusComponent implements OnInit{
  isProcessing: boolean = false;
  paymentStatuses: any[] = [];
  public errorMessage: string | null = null;
  public successMessage: string | null = null;
  searchText: string = '';
  page: number = 1;
  count: number = 0;
  itemsPerPage: number = 10; // default

  perPageOptions: number[] = [10, 20, 30, 50, 100]; // dropdown options

  ngOnInit(): void {
    this.isProcessing = true;
    this.getPaymentStatuses();
  }

  constructor(
    private paymentStatusService: PaymentStatusService
  ){}

  getPaymentStatuses(): void {
    this.paymentStatusService.fetchPaymentStatuses()
    .subscribe({
        next: (response) => {
          if(response.status==='success'){
            this.isProcessing = false;
            this.paymentStatuses = response.data

          }else{
            this.isProcessing = false;
            this.errorMessage=response.message;
          }
        },
        error: (error) => {
          this.isProcessing = false;
          this.errorMessage=error;
        }
      });
  }

  pageChangeEvent(page: number) {
    this.page = page;
  }

  onPerPageChange(event: Event) {
    const value = (event.target as HTMLSelectElement).value;
    this.itemsPerPage = Number(value);
    this.page = 1; // reset to first page
  }

  onSearchTextChange(event: Event) {
    this.searchText = (event.target as HTMLInputElement).value;
    this.page = 1; // Reset to page 1 after applying filter
  }

  //Apply different colour to each BL group
  rowColors: string[] = [
    'table-primary',
    'table-success',
    'table-warning',
    'table-info',
    'table-danger',
    'table-secondary'
  ];
  blColorMap: { [key: string]: string } = {};
  colorIndex = 0;

  getRowClass(blNo: string): string {
    if (!this.blColorMap[blNo]) {
      this.blColorMap[blNo] = this.rowColors[this.colorIndex % this.rowColors.length];
      this.colorIndex++;
    }
    return this.blColorMap[blNo];
  }
}
